import * as t from 'io-ts';

import { TMethod } from '../src/method';

type Params = {
  get: TMethod;
  apiHost: string;
};

const w4dPressureRemoteAPI = ({ apiHost, get }: Params) => ({
  readPressure: {
    path: `${apiHost}/v6/pressure`,
    method: get,
    response: t.type({
      pressure: t.Int,
    }),
  },
});

export { w4dPressureRemoteAPI };
